import script from "./Informacion.vue?vue&type=script&setup=true&lang=js"
export * from "./Informacion.vue?vue&type=script&setup=true&lang=js"

import "./Informacion.vue?vue&type=style&index=0&id=35fddd9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35fddd9c"]])

export default __exports__